var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStayAndWait(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 199.37 199.37",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M135.63,83.16v-19c0-10.91-7.61-14.77-14.76-14.77H78.39c-7.15,0-14.76,3.86-14.76,14.77v19a12.06,12.06,0,0,0-9.09,11.7V125.3c0,9,6,12.49,11.93,12.83h0v7.72a4.06,4.06,0,0,0,4.09,4.09h4.2a4.07,4.07,0,0,0,4.09-4.09v-7.72h41.68v7.72a4.06,4.06,0,0,0,4.09,4.09h4.2a4.07,4.07,0,0,0,4.09-4.09v-7.72h0c8.74-.45,11.92-6.81,11.92-12.83V94.75A12.42,12.42,0,0,0,135.63,83.16ZM78.39,53.41h42.48c4,0,10.67,1.36,10.67,10.67V82.71a12.1,12.1,0,0,0-11,12v2.84H78.73V94.75a12.1,12.1,0,0,0-11-12V64.2C67.72,54.88,74.42,53.41,78.39,53.41Zm.34,48.26h41.68v14.09H78.73Zm-4,44.18h-4.2v-7.72h4.2Zm49.74,0v-7.72h4.2v7.72Zm16.13-20.55c0,4-1.48,8.86-8.86,8.86H67.49c-4,0-8.86-1.48-8.86-8.86V94.75a8.07,8.07,0,1,1,16.13,0v23a2,2,0,0,0,2,2h45.77a2,2,0,0,0,2.05-2v-23a8.06,8.06,0,1,1,16.12,0V125.3Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStayAndWait);
export default __webpack_public_path__ + "static/media/stay-and-wait.907ef25ad0d9d6cc8a8d89c6e6af699f.svg";
export { ForwardRef as ReactComponent };